import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatDetail } from "@/lib/api";
import { Mail, CheckCircle2, ArrowRight } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  if (sent) {
    return (
      <div className="max-w-2xl mx-auto px-4 md:px-8 py-24 text-center" data-testid="forgot-sent">
        <div className="w-16 h-16 rounded-full mx-auto flex items-center justify-center" style={{ background: "rgba(37,211,102,0.14)" }}>
          <CheckCircle2 size={32} style={{ color: "#0A7A2C" }} />
        </div>
        <h1 className="font-display text-3xl mv-green-text mt-6">Check your email.</h1>
        <p className="mt-3 text-[15px]" style={{ color: "var(--mv-muted)" }}>
          If an account with <b>{email}</b> exists, we've sent a password reset link. It expires in 30 minutes.
        </p>
        <div className="mt-6 flex justify-center gap-3">
          <Link to="/login" className="btn-gold">Back to Login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-4 md:px-8 py-16 md:py-24" data-testid="forgot-password-page">
      <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>Password Reset</span></div>
      <h1 className="font-display text-3xl md:text-4xl mv-green-text mt-3 leading-tight">
        Forgot password? <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>No problem.</span>
      </h1>
      <p className="mt-4 text-[14.5px]" style={{ color: "var(--mv-muted)" }}>
        Enter the email you registered with. We'll send you a link to reset it.
      </p>
      <form onSubmit={submit} className="mt-8 mv-card p-6 md:p-7 space-y-4">
        <label className="block">
          <span className="text-[12.5px] uppercase tracking-[0.18em]" style={{ color: "var(--mv-muted)" }}>Email</span>
          <div className="mt-1 relative">
            <Mail size={16} className="absolute left-3.5 top-3.5" style={{ color: "var(--mv-muted)" }} />
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 rounded-xl border mv-hairline" data-testid="forgot-email" />
          </div>
        </label>
        <button type="submit" disabled={loading} className="btn-gold w-full justify-center disabled:opacity-60" data-testid="forgot-submit">
          {loading ? "Sending…" : (<>Send Reset Link <ArrowRight size={16}/></>)}
        </button>
        <p className="text-[13px] pt-2" style={{ color: "var(--mv-muted)" }}>
          <Link to="/login" className="mv-green-text underline">Back to login</Link>
        </p>
      </form>
    </div>
  );
}
